/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IOperationTheatre } from 'app/shared/model/operation-theatre.model';
import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { CalendarStatus } from 'app/shared/model/enumerations/calendar-status.model';
import { AllottedByType } from 'app/shared/model/enumerations/allotted-by-type.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface ISurgicalAppointment {
  id?: string;
  actualStartTime?: number;
  actualEndTime?: number;
  plannedStartTime?: number;
  plannedEndTime?: number;
  status?: keyof typeof CalendarStatus;
  bookedDate?: number | null;
  cancelledDate?: number | null;
  bookedByType?: keyof typeof AllottedByType;
  bookedById?: string;
  cancelledByType?: keyof typeof AllottedByType;
  cancelledById?: string;
  active?: boolean | null;
  cursor?: number | null;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  notes?: string | null;
  considerOnArrival?: string | null;
  handedOverToId?: string | null;
  handedOverToType?: keyof typeof AddedByType | null;
  takenOverById?: string | null;
  takenOverByType?: keyof typeof AddedByType | null;
  theatre?: IOperationTheatre;
  surgery?: IPatientProcedure;
}

export const defaultValue: Readonly<ISurgicalAppointment> = {
  active: false,
};
